import * as React from 'react'

import { Controller } from 'react-hook-form'

import StruxhubInput from '../../StruxhubInputs/StruxhubInput'
import { NumberFieldConfig } from '../types'

interface NumberFieldProps {
  field: NumberFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
}

export default function NumberField({
  field,
  control,
  error,
  hideHelperText,
}: NumberFieldProps) {
  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue || ''}
      rules={{
        required: field.required
          ? `${field.label || field.name} is required`
          : false,
      }}
      render={({ field: { onChange, value, name } }) => (
        <StruxhubInput
          label={field.label}
          placeholder={field.placeholder}
          type="number"
          negativeOrDecimal={true}
          value={value}
          onChange={e => onChange(e.target.value)}
          isRequired={field.required}
          isDisabled={field.disabled}
          isReadOnly={field.readOnly || field.displayOnly}
          isValid={!error}
          validationMessage={error}
          isHelperTextHidden={hideHelperText}
          name={name}
        />
      )}
    />
  )
}
